import CreateProject from "@/views/projects/CreateProject.vue";
import ProjectPage from "@/views/projects/ProjectPage.vue";
import ProjectBase from "@/views/projects/TheBase.vue";

export default [
  // Create page
  {
    path: "create",
    name: "CreateProject",
    component: CreateProject,
    meta: {
      goto: "LocalPatientList"
    }
  },

  // View project
  {
    path: ":projectUuid",
    component: ProjectBase,
    children: [
      {
        path: "",
        component: ProjectPage,
        name: "ProjectPage",
        meta: {
          goto: "LocalPatientList"
        }
      }
    ]
  }
];
